import { Account } from "../model/account/Account";

export class AccountSaveCommand{
    account: Account;

    constructor(account: Account){
        this.account = account;
    }
}